module.exports = __webpack_public_path__ + "static/media/kz.765abf25.svg";